import Company from 'components/Pages/Registration/Company/Company';

export default Company;
